<template>
	<div class="b360-label-holder" :class="{ 'visually-hidden': hidden }">
		<label
			class="b360-form-label"
			:class="{
				'remove-margin--bottom': isComplianceLogo,
				'no-bottom-margin': isChangeContactType,
			}"
			data-test="form-label"
			:for="name"
			>{{ label }}
			<font-awesome-icon
				v-if="required"
				class="asterisk"
				:icon="['fas', 'asterisk']"
				v-tooltip="{
					content: 'This is a required field',
					trigger: 'hover click',
					placement: 'top-end',
				}"
		/></label>
		<font-awesome-icon
			class="tooltip-target b360-form-icon"
			:icon="['fal', 'question-circle']"
			v-tooltip="{
				content: tooltip,
				trigger: 'hover click',
				placement: 'top-end',
			}"
			v-if="tooltip"
		/>
	</div>
</template>

<script>
export default {
	name: 'FormLabelTooltip',
	props: {
		name: String,
		label: String,
		tooltip: String,
		required: Boolean,
		hidden: Boolean,
	},
	computed: {
		isComplianceLogo() {
			return this.label ? this.label.startsWith('Compliance Logos') : false;
		},
		isChangeContactType() {
			return this.label ? this.label.startsWith('Change Contact Type') : false;
		},
	},
};
</script>

<style lang="scss">
.b360-form-label {
	display: flex;
	justify-content: space-between;

	.asterisk {
		color: $brand-blue;
		font-size: $b360-font-size--smallest;
	}

	&.remove-margin--bottom {
		@include rem('margin-bottom', -15px);
	}
	&.no-bottom-margin {
		margin-bottom: 0;
	}
}
</style>
